<div fxLayout="column">
  <ng-container *ngIf="jobStatus.status === JobStatus.IN_PROGRESS || jobStatus.status === JobStatus.WAITING">
    <div fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
      <mat-spinner mode="indeterminate" color="accent" diameter="64" strokeWidth="5"></mat-spinner>
      <span>{{ 'MASSIVE_COMPANY_DIALOG.WAITING_UPDATE' | translate }}</span>
    </div>
  </ng-container>

  <ng-container *ngIf="jobStatus.status === JobStatus.ERROR">
    <h2>{{ 'MASSIVE_COMPANY_DIALOG.ERROR.ERROR' | translate }}</h2>

    <ul fxFlex>
      <li *ngFor="let error of jobStatus.errors">
        <span>{{ error }}</span>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="jobStatus.status === JobStatus.COMPLETED">

    <form [formGroup]="form">
      <div fxLayout="column">
        <!-- Main company form -->
        <div class="mat-h2">{{ getMainCompanyType() | titlecase }}: {{ getMainCompanyDescription() }}</div>

        <ng-container formGroupName="mainCompany">

          <!-- Firstname and Lastname -->
          <div fxLayout="row" fxLayoutGap="16px">
            <mat-form-field fxFlex="50" appearance="fill">
              <mat-label>{{ 'MASSIVE_COMPANY_DIALOG.FIRST_NAME' | translate }}</mat-label>
              <input
                matInput
                type="text"
                formControlName="legalRepresentativeFirstName">
            </mat-form-field>

            <mat-form-field fxFlex="50" appearance="fill">
              <mat-label>{{ 'MASSIVE_COMPANY_DIALOG.LAST_NAME' | translate }}</mat-label>
              <input
                matInput
                type="text"
                formControlName="legalRepresentativeLastName">
            </mat-form-field>
          </div>

          <!-- Mail and Phone -->
          <div fxLayout="row" fxLayoutGap="16px">
            <mat-form-field fxFlex="50" appearance="fill">
              <mat-label>{{ 'MASSIVE_COMPANY_DIALOG.EMAIL' | translate }}</mat-label>
              <input
                matInput
                type="email"
                formControlName="legalRepresentativeEmail">
            </mat-form-field>

            <mat-form-field fxFlex="50" appearance="fill">
              <mat-label>{{ 'MASSIVE_COMPANY_DIALOG.PHONE' | translate }}</mat-label>
              <input
                matInput
                type="text"
                formControlName="legalRepresentativePhone">
            </mat-form-field>
          </div>

        </ng-container>

        <!-- Related companies form -->
        <div style="margin-top:24px">
          <div class="mat-h2"> {{ isMainCompanySeller ? 'Clienti' : 'Fornitori' }} </div>

          <ul>
            <li *ngFor="let group of relatedFormsGroups().controls; let index = index">
              <div class="mat-h3 mb-0">{{ getRelatedCompanyDescription(index) }}</div>
            </li>
          </ul>
        </div>
      </div>
    </form>
  </ng-container>
</div>

